import { ApiBaseFront } from '../api-base-front';
import {ApiBaseFrontFix} from "../api-base-front-fix";

type ParamType = {
  kijshopCd: string;
  orderId: string,
  orderStyleInfo: OrderStyleInfoParam[],
}

export type OrderStyleInfoParam = {
  orderInfoDataId: string,
  orderName: string,
  folderName: string,
  orderStyleName: string,
  orderNum: number,
  pageCount: number,
  boardInfoName: string,
  cover: {
  partName: string,
    colorName: string,
  },
  option: {
    orderName: string,
  }[],
}

// TODO 緊急対応で継承元クラスを変えているので本番反映後に修正しテストする
export class ApiCloudFolderInsertOrderStyleInfo extends ApiBaseFrontFix {
  constructor(_param: ParamType) {
    const { kijshopCd, orderId, ...param } = _param;
    super(
      'POST',
      `/api/v1/olc/shop/${kijshopCd}/order/${orderId}/orderStyleInfo`,
      'JSON',
      param,
    );
  }
}
